const convertFlagToBool = (flag: string, name: string): boolean | undefined => {
  if (flag) {
    const tmp = flag.toLowerCase().trim()
    if (tmp === 'true') {
      return true
    } else if (tmp === 'false') {
      return false
    } else {
      // eslint-disable-next-line no-console
      console.error(`FLAG ERROR: o valor "${flag}" de ${name} não é booleano`)
      return undefined
    }
  }
}

/**
 * Habilita todos as flags experimentais
 */
export const EXPERIMENTAL = convertFlagToBool(process.env.REACT_APP_EXPERIMENTAL, 'REACT_APP_EXPERIMENTAL')

/**
 * Especifica se as telas novas de atendimento devem ser mostradas
 */

export const ATENDIMENTO_NOVO_ENABLED =
  convertFlagToBool(process.env.REACT_APP_ATENDIMENTO_NOVO_ENABLED, 'REACT_APP_ATENDIMENTO_NOVO_ENABLED') ??
  EXPERIMENTAL

export const ATENDIMENTO_ANTIGO_DISABLED = convertFlagToBool(
  process.env.REACT_APP_ATENDIMENTO_ANTIGO_DISABLED,
  'REACT_APP_ATENDIMENTO_ANTIGO_DISABLED'
)

export const ATENDIMENTO_ODONTOLOGICO_ENABLED =
  convertFlagToBool(
    process.env.REACT_APP_ATENDIMENTO_ODONTOLOGICO_ENABLED,
    'REACT_APP_ATENDIMENTO_ODONTOLOGICO_ENABLED'
  ) ?? EXPERIMENTAL

export const UNIFICACAO_BASE_ENABLED =
  convertFlagToBool(process.env.REACT_APP_UNIFICACAO_BASE_ENABLED, 'REACT_APP_UNIFICACAO_BASE_ENABLED') ?? EXPERIMENTAL

export const UNIFICACAO_BASE_TEST_ENABLED =
  convertFlagToBool(process.env.REACT_APP_UNIFICACAO_BASE_TEST_ENABLED, 'REACT_APP_UNIFICACAO_BASE_TEST_ENABLED') ??
  EXPERIMENTAL

export const CEO_ENABLED = convertFlagToBool(process.env.REACT_APP_CEO_ENABLED, 'REACT_APP_CEO_ENABLED')

export const ESCUTA_INICIAL_ENABLED =
  convertFlagToBool(process.env.REACT_APP_ESCUTA_INICIAL_ENABLED, 'REACT_APP_ESCUTA_INICIAL_ENABLED') ?? EXPERIMENTAL

export const PUERICULTURA_ENABLED =
  convertFlagToBool(process.env.REACT_APP_PUERICULTURA_ENABLED, 'REACT_APP_PUERICULTURA_ENABLED') ?? EXPERIMENTAL

export const PERIODONTIA_ENABLED =
  convertFlagToBool(process.env.REACT_APP_PERIODONTIA_ENABLED, 'REACT_APP_PERIODONTIA_ENABLED') ?? EXPERIMENTAL
